import { makeStyles } from '@material-ui/styles'

export default makeStyles(theme => ({
    appBar: {
        background: 'transparent',
        boxShadow: 'none',
        transition: 'background .2s ease',
        zIndex: theme.zIndexLevels.nine,

        '&.dark': {
            background: '#151a24',
        },
    },

    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    logoWrapper: {
        display: 'flex',
        alignItems: 'flex-end',

        '& h6': {
            ...theme.typographyPresets.titleSmallLight,
            marginLeft: 10,
            color: 'hsla(0,0%,100%,.5)',
            letterSpacing: 1.5,
            fontSize: 10,
            marginBottom: 5,

            [theme.breakpoints.up('md')]: {
                fontSize: 16,
                marginBottom: 0,
            },
        },
    },
    logo: {
        height: 15,

        [theme.breakpoints.up('md')]: {
            height: 22,
        },
    },
    liveDot: {
        width: 6,
        height: 6,
        opacity: 0.6,
        backgroundImage: '-webkit-linear-gradient(44deg, #f73153, #fa7f0f)',
        // eslint-disable-next-line no-dupe-keys
        backgroundImage: 'linear-gradient(46deg, #f73153, #fa7f0f)',
        borderRadius: 3,
        display: 'inline-block',
        marginRight: 5,
    },
    navItemsWrapper: {
        display: 'flex',
        alignItems: 'center',
    },
    navDivider: {
        borderRight: '1px solid hsla(0,0%,100%,.2)',
        borderTop: '1px solid hsla(0,0%,100%,.2)',

        [theme.breakpoints.up('md')]: {
            height: 18,
        },
    },
    menuItem: {
        ...theme.typographyPresets.bodyTertiary,
        color: theme.colors.white,
        textTransform: 'uppercase',
        opacity: 0.6,
        paddingRight: 12,
        paddingLeft: 12,
        fontSize: 12,
        lineBreak: 1.5,
        letterSpacing: 0.48,
        fontWeight: 700,
        display: 'inline-block',

        '&:hover': {
            color: 'hsla(0,0%,100%,.75)',
        },
        '&.active': {
            opacity: 1,

            '&:hover': {
                color: theme.colors.white,
            },
        },
        '&.active:not(.mobile)': {
            marginTop: 11,

            '&::after': {
                content: '""',
                display: 'block',
                margin: '0 auto',
                borderBottom: '3px solid #fff',
                paddingTop: 8,
            },
        },
    },
    reducePaddingLeft: {
        paddingLeft: 1,
    },
    menuButton: {
        marginLeft: 10,
    },
    hamburgerIcon: {
        width: 30,
        height: 30,
        background: `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='rgba(255, 255, 255, 1)' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>")`,
    },
}))
